// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pMZP","delete":"styles_delete__1V1Jq","update":"styles_update__3E4bP","add":"styles_add__3-dTD"};